export const MedicalCompanion = {
    path: '/medical_companions',
    name: 'medical_companions',
    component: () => import('@/views/Medical/Companion/MedicalCompanionPage.vue'),
    children: [
        {
            path: '/medical_companions/add',
            name: 'medical_companions.add',
            component: () => import('@/views/Medical/Companion/Form/MedicalCompanionForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/medical_companions/edit/:id',
            name: 'medical_companions.edit',
            component: () => import('@/views/Medical/Companion/Form/MedicalCompanionForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/medical_companions/delete/:id',
            name: 'medical_companions.delete',
            component: () => import('@/views/Medical/Companion/Form/MedicalCompanionForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/medical_companions/view/:id',
            name: 'medical_companions.view',
            component: () => import('@/views/Medical/Companion/Form/MedicalCompanionForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/medical_companions/documents/:id',
            name: 'medical_companions.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "MEDICAL_COMPANION"}
        },
        {
            path: '/medical_companions/template_applications/:id',
            name: 'medical_companions.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "MEDICAL_COMPANION"}
        },
    ]
}